
export default{
        appName:"H6",
        home:"首页",
        about:"关于",
        download:"下载",
        theme:{
            title:"",
            desc:"随时随地和好友聊天\n互发语音以及视频通话"
        },
        model1:{
            title:"消息传递快速安全且加密",
            desc:"您的隐私是我们的头等大事。借助端到端加密技术，您可以确保您的个人消息只有您和接收人才能看到。"
        },
        model2:{
            title:"自由自在地交谈",
            desc:"端到端加密让你的个人消息和通话更有安全保障。只有与您交谈的人和您自己可以读取或收听消息内容。除此之外，其他任何人（甚至包括H6）都无法得知。",
            li01:{
                title:"免费",
                desc:"H6提供免费且安全消息传递。"
            },
            li02:{
                title:"安全",
                desc:"H6保护您的消息描述黑客攻击。"
            },
            li03:{
                title:"快速的",
                desc:"传递消息的速度比任何其他应用程序都快。"
            },
            li04:{
                title:"隐私",
                desc:"H6采用端对端加码。"
            },
            li05:{
                title:"防窃听",
                desc:"使用中继线呼叫技术加密通信，确保您的IP信息安全。"
            },
            li06:{
                title:"简单的",
                desc:"H6非常简单，您已经知道如何使用它。"
            }
        },
        model3:{
            title:"拨通语音和视频通话\n分享彼此的精彩世界",
            desc:"分享您的精彩世界。 发送照片和文件、语音和视频通话，不限大小。 眨眼间即可获得奶奶的秘方。"
        },
        model4:{
            title:"利用群组，保持联络",
            desc:"通过简单的群组和社群信息，与关系最密切的群组保持联系。"
        },
        model5:{
            title:"下载H6",
            desc:"在多个设备使用H6持续沟通交流，对话从不间断"
        },
        footer:{
            desc:"一款基于云的移动消息传递应用程序，注重安全性和速度。",
            privacy:"隐私条款",
            clientAgreement:"客户协议",
            icp:"网站备案号",
            icpNo:"粤ICP备2025364668号-1",
            contact:"联系方式",
            email:"邮箱：",
            mobile:"手机号：",
        },
        platform:{
            title:"一款基于云消息的应用程序",
            subTitle:"注重安全和速度",
            downBtn:"下载H6",
            downloading:"正在跳转下载中...",
            downloadHint:"请稍候",
        },
        report:{
            t01:"请选择投诉该账号的原因：",
            t02:"投诉须知",
            list01:"发布不适当内容对我造成骚扰",
            list02:"存在欺诈骗钱行为",
            list03:"此账号可能被盗用了",
            list04:"存在侵权行为(侵犯知识产权、 人身权)",
            list05:"发布仿冒品信息",
            list06:"冒充他人",
            list07:"侵犯未成年人权益",
            list08:"粉丝无底线追星行为",
            t03:"举报成功，感谢您的反馈",
            t04:"返回",
        }
    
}